module.exports = __webpack_public_path__ + "img/instruction-ios-02.00203555.png";